var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["mobile-page-select", { sticky: false, scrolled: false }],
      style: {
        "--down-chevron": "url(" + _vm.downChevron + ")",
        "--down-chevron-blue": "url(" + _vm.downChevronBlue + ")",
        "--down-chevron-dark-blue": "url(" + _vm.downChevronDarkBlue + ")",
      },
    },
    [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedPage,
              expression: "selectedPage",
            },
          ],
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedPage = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.handlePageChange,
            ],
          },
        },
        [
          _c(
            "option",
            { attrs: { selected: "" }, domProps: { value: _vm.selectedPage } },
            [_vm._v("Jump to section")]
          ),
          _vm._v(" "),
          _vm._l(_vm.parsedPages, function (page, index) {
            return _c("option", {
              key: index,
              domProps: {
                value: page.anchor_link ? page.anchor_link.url : "top",
                innerHTML: _vm._s(
                  page.anchor_link ? page.anchor_link.title : "Untitled"
                ),
              },
            })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }